import { sendEvent } from '@nubank/www-latam-commons/services/analytics';

export const trackInsuranceSimulation = () => {
  sendEvent('INSURANCE_SIMULATE_BUTTON_CLICKED');
};
